<template>
    <footer class="fixed-bottom footer">

        <a href="#" class="button-footer cancel-order " @click.prevent="cancelOrder()">
            CANCELAR PEDIDO
            <font-awesome-icon icon="times-circle"/>
        </a>


        <a href="#" class="confirm-order button-footer " @click.prevent="finishOrder()">
            FINALIZAR PEDIDO
            <font-awesome-icon icon="check-circle"/>
        </a>

    </footer>
</template>

<script>
  import {mapGetters} from 'vuex';

  export default {
    name: 'ProductsFooter',

    computed: {
      ...mapGetters({getCart: 'getCart'}),
    },
    methods: {
      async cancelOrder() {
        await this.$router.push({name: 'standby'});
      },
      async finishOrder() {
        if (this.getCart.hasItems) {
          await this.$router.push({name: 'cart'});
          return;
        }
        this.$swal({
          title: 'Coloque items no carrinho para finalizar',
          type: 'warning',
          confirmButtonText: 'Entendi',

        });
      },
    },

  };
</script>

<style scoped>

    .footer {
        height: 100px;
        background-color: var(--dark-orange);
    }

    .button-footer {
        width: 50%;
        height: 100px;
        color: #fff;
        float: left;
        text-decoration: none !important;
        font-weight: bold;
        font-size: 23px;
        padding: 34px;
        text-align: center;
    }

    .cancel-order {
        background-color: var(--dark-orange);
    }

    .confirm-order {
        background-color: var(--dark-green);

    }
</style>
